import { stringify } from 'query-string';
import { useCallback } from 'react';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
const useAction = (pathname, query) => {
    const history = useNavigate();
    const onPageChange = useCallback(({ selected }) => {
        const newQuery = stringify(Object.assign(Object.assign({}, query), { page: selected + 1 }));
        history.push(`${pathname}?${newQuery}`);
    }, [history, query, pathname]);
    const onBlurKeyword = useCallback((e) => {
        const searchText = e.currentTarget.value;
        const newQuery = stringify(Object.assign(Object.assign({}, query), { searchText }));
        history.replace(`${pathname}?${newQuery}`);
    }, [history, pathname, query]);
    return {
        onBlurKeyword,
        onPageChange,
    };
};
export const useMyPageFolderTable = {
    useAction,
};
export default useMyPageFolderTable;
